import { MenuItem, Select, Stack } from '@mui/material';
import React, { useState } from 'react';
import { useGetPacksQuery } from '../../../../api/apiSlice';
import { useParams } from 'react-router';
import PackUsageForm from './PackUsageForm';

function PackUsageManagement() {
    const organizationId = useParams().organizationId;
    const { data: packs = [], isLoading, isSuccess } = useGetPacksQuery(organizationId);
    const [selectedPack, setSelectedPack] = useState();

    return (
        <Stack p={4} spacing={4}>
            <h1>Pack Usage Management</h1>
            <Select
                value={selectedPack}
                onChange={(e) => setSelectedPack(e.target.value)}
                placeholder='Select a Pack'
                fullWidth
                disabled={isLoading}
            >
                {isSuccess && packs.map((pack) => (
                    <MenuItem key={pack.id} value={pack.id}>
                        {pack.items[0]?.name || `Pack ${pack.id}`}
                    </MenuItem>
                ))}
            </Select>
            { selectedPack &&
                <PackUsageForm pack={packs.find(p => p.id === selectedPack)} />
            }
        </Stack>
    );
}

export default PackUsageManagement;
